import { render, staticRenderFns } from "./PresenceAbsences.vue?vue&type=template&id=4937eea2&scoped=true&"
import script from "./PresenceAbsences.vue?vue&type=script&lang=js&"
export * from "./PresenceAbsences.vue?vue&type=script&lang=js&"
import style0 from "./PresenceAbsences.vue?vue&type=style&index=0&id=4937eea2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937eea2",
  null
  
)

export default component.exports